<template>
  <div style="overflow: auto">
    <table class="table">
      <thead>
        <tr style="background-color: #6b6b6b;">
          <td class="tdBorder">
            <div class="py-2">
              <span class="d-block spandHeadO">{{ t("orders.orderNo") }}</span>
            </div>
          </td>
          <td class="tdBorder orderDate">
            <div class="py-2">
              <span class="d-block spandHeadO">{{ t("orders.createDate") }}</span>
            </div>
          </td>
          <td class="tdBorder">
            <div class="py-2">
              <span class="d-block spandHeadO">{{ t("orders.status") }}</span>
            </div>
          </td>
          <td class="tdBorder">
            <div class="py-2">
              <span class="d-block spandHeadO">{{ t("orders.orderTotal") }}</span>
            </div>
          </td>
          <td class="tdBorder">
            <div class="py-2">
              <span class="d-block spandHeadO">{{ t("global.action") }}</span>
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in orders.data" :key="order.id">
          <td class="bodytr font-weight-bold">
            {{ order.id }}
          </td>
          <td class="bodytr orderDate">
            <span class="">{{ dateFormat(order.created_at) }}</span>
          </td>
          <td class="bodytr">
            <span v-if="order.m_status == 'pending_payment'" class="badge badge-warning text-capitalize">
              {{ t(`orders.mStatus.${order.m_status}`) }}
            </span>

            <span v-else-if="order.m_status == 'processing'" class="badge badge-info text-capitalize">
              {{ t(`orders.mStatus.${order.m_status}`) }}
            </span>

            <span v-else-if="order.m_status == 'already_delivery'" class="badge badge-info text-capitalize">
              {{ t(`orders.mStatus.${order.m_status}`) }}
            </span>

            <span v-else-if="order.m_status == 'done'" class="badge badge-success text-capitalize">
              {{ t(`orders.mStatus.${order.m_status}`) }}
            </span>

            <span v-else-if="order.m_status == 'abnormal_done'" class="badge badge-danger text-capitalize">
              {{ t(`orders.mStatus.${order.m_status}`) }}
            </span>

            <span v-else class="badge badge-dark text-capitalize">
              {{ t(`orders.mStatus.${order.m_status}`) }}
            </span>
          </td>
          <td class="bodytr">{{ checkValidCurrencyStr(order.total, order.currency) }}</td>
          <td class="bodytr">
            <a :href="`/account/orders/${order.uuid}`" class="btn btn-primary p-2 mr-2">
              <i class="fa fa-eye"></i> {{ t("global.view") }}
            </a>

            <button
              v-if="!chkPreviewInvoice(order.invoice_data)"
              class="btn btn-warning p-2 mr-2 top-margin"
              @click="onClickPreviewInvoice(order.invoice_data)"
            >
              <i class="fa fa-print"></i> 
              發票預覽
            </button>

            <button
              v-if="order.m_status == 'pending_payment'"
              class="btn btn-danger p-2 mr-2 top-margin"
              @click="onClickCancel(order.uuid)"
            >
              <i class="fa fa-trash"></i> {{ t("global.cancel") }}
            </button>

            <a v-if="order.m_status == 'pending_payment'" :href="order.payment_url"
               class="btn btn-info p-2 mr-2 top-margin">
                <i class="fa fa-money"></i> {{ t("subscriptions.goToPayment") }}
            </a>

            <button
              v-if="order.m_status == 'pending_payment'"
              class="btn btn-secondary p-2 top-margin"
              @click="onClickChangePayment(order)"
            >
              <i class="fa fa-pencil-square-o"></i> {{ t("subscriptions.changePaymentMethod") }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!orders.data.length" class="mt-3 mb-2 text-center">
      {{ t("orders.empty") }}
    </div>
    <div v-if="orders.paging" class="card-footer">
      <!-- Pagination-->
      <nav class="d-flex justify-content-between pt-2" aria-label="Page navigation">
        <ul class="pagination">
          <li class="page-item">
            <el-button :disabled="orders.paging.page - 1 < 1" @click="handlePrePage">
              <i class="czi-arrow-left mr-2"></i>
              {{ t("paging.prevPage") }}
            </el-button>
          </li>
        </ul>
        <ul class="pagination">
            <li class="page-item d-none d-sm-block">
              <span class="page-link page-link-static">
                {{orders.paging.page}} / {{totalPage}} ({{ t("paging.totalCount", [orders.paging.total_count]) }})
              </span>
            </li>

            <li class="page-item d-sm-none">
              {{ t("paging.totalCount", [orders.paging.total_count]) }}
            </li>

            <!-- <li class="page-item active d-none d-sm-block" aria-current="page"><span class="page-link">1</span></li>
            <li v-for="" class="page-item d-none d-sm-block"><a class="page-link" href="#">2</a></li>
            <li class="page-item d-none d-sm-block"><a class="page-link" href="#">3</a></li>
            <li class="page-item d-none d-sm-block"><a class="page-link" href="#">4</a></li>
            <li class="page-item d-none d-sm-block"><a class="page-link" href="#">5</a></li> -->
        </ul>
        <ul class="pagination">
            <li class="page-item">
              <el-button :disabled="orders.paging.page + 1 > totalPage" @click="handleNextPage">
                {{ t("paging.nextPage") }}
                <i class="czi-arrow-right ml-2"></i>
              </el-button>
            </li>
        </ul>
      </nav>
    </div>

    <el-dialog v-model="dialogState.visible" :title="t('subscriptions.changePaymentMethod')">
      <el-form :model="dialogState.data">
        <el-form-item>
          <el-radio-group v-model="dialogState.data.payment_type" size="large" class="w-100 row m-0 justify-content-center">
            <el-radio
              v-for="payment in payments"
              :key="payment.type"
              :label="payment.type"
              border
              class="col-12 mb-2 mx-1"
              :style="{ minHeight: '5rem', margin: '0 0rem 0 0' }"
            >
              {{ dt(payment.name_translations) }}
              <div v-if="payment.show_description_on_checkout" class="text-black-50">
                {{ dt(payment.description_translations) }}
              </div>
              <div v-if="payment.type == 'ECPAY'" class="text-black-50">
                請點擊前往付款至綠界AIO變更付款方式
              </div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogState.visible = false">{{ t("global.cancel") }}</el-button>
          <el-button type="primary" @click="handleChangePayment"
            >{{ t("global.ok") }}</el-button
          >
        </span>
      </template>
    </el-dialog>

    <!-- <pre>{{ systemConfig }}</pre> -->
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted } from 'vue'
import { useI18n } from "vue-i18n"
import { notificationErrors, dateFormat, dataTranslations as dt, checkValidCurrencyStr } from "../../utils"
import { ElNotification } from 'element-plus'
import { _api_getOrders, _api_postCancelOrder, _api_putOrderPaymemnt } from "../../api/index.js";
import { getPrintUrl } from "../../api/aib-invoice.js";

const props = defineProps({
  payments: Array,
  systemConfig: Object,
})

const { t, n, locale } = useI18n()

const totalPage = computed(() => orders.paging ? Math.ceil(orders.paging.total_count / orders.paging.limit) : null)
const filterParams = reactive({
  fields: "invoice_data",
  page: 1,
  limit: 10,
})
const orders = reactive({
  data: [],
  paging: null,
})
const dialogState = reactive({
  visible: false,
  uuid: null,
  data: {
    payment_type: null,
  },
})

const getData = async () => {
  window.fullPageLoading("show")
  try {
    const resp = await _api_getOrders(filterParams)
    orders.data = resp.data
    orders.paging = resp.paging
  } catch (err) {
    notificationErrors(err)
  } finally {
    window.fullPageLoading("hide")
  }
}
const onClickCancel = (uuid) => {

  swal.fire({
    title: t("global.areYouSure"),
    text: t("orders.cancelOrder"),
    type: 'warning',
    showCancelButton: true,
    cancelButtonText: t("global.close"),
    confirmButtonText: t("global.confirmCancel"),
  }).then(async (result) => {
    if (result.value) {
      window.fullPageLoading("show")
      try {
        await _api_postCancelOrder(uuid, { reason	: t("orders.CancellationByCustomer") })
        dialogState.visible = false
        getData()
        ElNotification({
          title: t("orders.canceled"),
          // message: 'This is a success message',
          type: 'success',
          position: 'bottom-left',
        })
      } catch (err) {
        // console.log("handleChangePayment Fail: ", err)
        notificationErrors(err.response.data)
      } finally {
        window.fullPageLoading("hide")
      }

    }
  })
}
const handleChangePayment = async () => {
  window.fullPageLoading("show")
  try {
    await _api_putOrderPaymemnt(dialogState.uuid, dialogState.data)
    dialogState.visible = false
    getData()
    ElNotification({
      title: t("subscriptions.changePaymentMethodSuccess"),
      // message: 'This is a success message',
      type: 'success',
      position: 'bottom-left',
    })
  } catch (err) {
    // console.log("handleChangePayment Fail: ", err)
    notificationErrors(err.response.data)
  } finally {
    window.fullPageLoading("hide")
  }
}
const onClickChangePayment = (item) => {
  dialogState.uuid = item.uuid
  dialogState.data.payment_type = item.payment_type
  dialogState.visible = true
}
const handlePrePage = () => {
  filterParams.page--
  getData()
}
const handleNextPage = () => {
  filterParams.page++
  getData()
}
const chkPreviewInvoice = (data) => {
  // console.debug("data: ", data)
  if (data?.extra_metadata?.uuid && data?.extra_metadata?.invoice_status != "PND00") {
    return false
  }
  return true
}
const onClickPreviewInvoice = async (data) => {
  const uuid = data?.extra_metadata?.uuid
  if (!uuid) {
    return
  }
  window.fullPageLoading("show")
  try {
    const resp = await getPrintUrl(props.systemConfig, uuid)
    // console.debug("onClickPreviewInvoice: ", resp)
    if (resp?.url) {
      window.open(resp?.url)
    }
  } catch (error) {
    // console.debug("handleChangePayment Fail: ", error.response.data)
    notificationErrors(error.response.data)
  } finally {
    window.fullPageLoading("hide")
  }
}

onMounted(() => {
  getData()
})
</script>
<style>
/* tr {
  border-style: hidden !important;
} */
</style>
